export const ACCESS_TOKEN = 'ACCESS-TOKEN'; // 用户token
export const CURRENT_USER = 'CURRENT-USER'; // 当前用户信息
export const IS_LOCKSCREEN = 'IS-LOCKSCREEN'; // 是否锁屏
export const TABS_ROUTES = 'TABS-ROUTES'; // 标签页
export const LOGIN_STATE = 'LOGIN-STATE'; // 用户登录状态
export const PASSWORD_STATUS = 'PASSWORD_STATUS'; //密码修改状态根据登录次数来 1 只有1的情况执行弹框
